
import { defineComponent, onMounted, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import { ToggleComponent } from "@/assets/ts/components/_ToggleComponent";
import KTMenu from "@/layout/aside/Menu.vue";
import { asideTheme } from "@/core/helpers/config";
/* import KTUserMenu from "@/layout/header/partials/UserMenu.vue"; */
import { CookieComponent } from "@/assets/ts/components";

export default defineComponent({
  name: "KTAside",
  components: {
    KTMenu,
    /*     KTUserMenu, */
  },
  props: {
    lightLogo: String,
    darkLogo: String,
  },
  computed: {
    userName() {
      if (CookieComponent.get("userData") != undefined)
        return JSON.parse(CookieComponent.get("userData") as string).fullName;
      else return "test";
    },
  },
  setup() {
    const { t } = useI18n();

    onMounted(() => {
      ToggleComponent.reinitialization();
    });

    onUpdated(() => {
      ToggleComponent.bootstrap();
    });

    return {
      asideTheme,
      t,
    };
  },
});
